import styles from './index.module.less';
import Image from 'next/image';
const Index = ({ compareSummary, alternativeBasic, websiteBasic }: any) => {
  return (
    <div className={styles.container}>
      <div className={styles.firstCompare}>
        <Image src={alternativeBasic.imgPath} alt={alternativeBasic.title} height={40} priority width={130} />
        <span>vs</span>
        <Image src={websiteBasic.imgPath} alt={websiteBasic.title} height={40} priority width={130} />
      </div>
      <h2 className={styles.title}>{compareSummary.title}</h2>
      <div className={styles.description}>{compareSummary.description}</div>
      <div className={styles.main}>
        <div className={styles.left}>
          <Image src={compareSummary.imgPath} alt={compareSummary.title} height={301} priority width={400} />
        </div>
        <div className={styles.right}>
          {compareSummary.details.map((item: any, index: number) => (
            <div className={styles.item} key={index}>
              <h3 className={styles.itemTitle}>{item.title}</h3>
              <div className={styles.desc}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Index;
